/**
 * this component is supposed to represent a casting. 
 * A casting has a name and additionally a note specifying its usage, 
 * this will be set in the creation component, but it would make sense to give the option to alter it here.
 * The models selected for the casting are displayed with the option to accept or decline them.
 * Also there is the given possibility to add models to the casting during the casting process.
 * When the Casting process is over, a booking can be generated via a button click.
 */

import React, { useState, useEffect } from 'react';
import CreatePool from '../CreatePool';
import RenderModels from '../../RenderModels';
import { fetchPoolModels } from '../../../utils/Pool/fetchPoolModels';
import CreateCasting from './CreateCasting';
import PDFCasting from './PDFCasting'
import { PDFDownloadLink } from '@react-pdf/renderer';
import { fetchModelAssets } from '../../../utils/models/fetchModelAssets';

const CastingView = ({ selectedCasting = null, setSelectedCasting = () => { }, castings }) => {
  const [editingCasting, setEditingCasting] = useState(false); // Track casting being edited
  const [models, setModels] = useState([]);
  const [modelStatus, setModelStatus] = useState([])
  const [loading, setLoading] = useState(false);
  const [modelPage, setModelPage] = useState(1); // Page for models
  const [totalModelPages, setTotalModelPages] = useState(1); // Total model pages
  const [modelsWithAssets, setModelsWithAssets] = useState([]);

  const MODELS_PER_PAGE = 10; // Number of models to fetch per page

  useEffect(() => {
    if (selectedCasting) {
      fetchPoolModels(selectedCasting.pool_id, setModels, setTotalModelPages, setLoading, modelPage, MODELS_PER_PAGE);
    }
  }, [selectedCasting, modelPage]);

  useEffect(() => {
    prepareModelsForCasting(models).then(setModelsWithAssets);
  }, [models]);

  const prepareModelsForCasting = async (models) => {
    const enrichedModels = [];

    for (const model of models) {
      const result = await fetchModelAssets(model);
      enrichedModels.push(result);
    }

    return enrichedModels;
  };


  const handleEditCasting = async () => {
    setEditingCasting(true);
  };

  const handleBackToCastings = () => {
    setSelectedCasting(null); // Deselect the pool
    setModels([]); // Clear models
  };

  const handleModelPageChange = (direction) => {
    const newPage = modelPage + direction;
    if (newPage > 0 && newPage <= totalModelPages) {
      setModelPage(newPage);
    }
  };

  const handleModelStatusChange = (modelid, status) => {

  };

  const renderCastingBar = (model) => {
    return (
      <div>
        <button
          className={`button`}
          onClick={() => handleModelStatusChange(model.id, 'accepted')}
        >
          Accept
        </button>
        <button
          className={`button`}
          onClick={() => handleModelStatusChange(model.id, 'declined')}
        >
          Decline
        </button>
      </div >);
  };

  return (
    editingCasting ? (
      <CreateCasting
        pools={castings}
        onBack={() => { setEditingCasting(false) }} // Reset editingPool on back
        pool={selectedCasting}
        poolId={selectedCasting.pool_id}
      />
    ) : (
      <div className="models-all">
        <div style={{ textAlign: 'left' }}>
          <h4>Customer: "Customer"</h4>
          <br />
          <label>Note:</label><br />
          <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>
          <br />
          <br />
          <button className="button" onClick={handleBackToCastings}>
            Back to Castings
          </button>
          <button className="button" onClick={handleEditCasting}>
            Edit Casting
          </button>
          <PDFDownloadLink document={<PDFCasting models={modelsWithAssets} casting={selectedCasting} />} fileName="CastinggPDF">
            {({ loading }) => loading ? (<button className="button" disabled={true}>Loading PDF...</button>) : (<button className="button">Download PDF</button>)}
          </PDFDownloadLink>
        </div>
        <h1 className="modal-title">Models in {selectedCasting.pool_id}</h1>
        <div className="model-list">
          {loading ? (
            <p>Loading models...</p>
          ) :

            <div className='models-all'>
              {console.log("models:", models)}
              <RenderModels models={models} castingBar={renderCastingBar} />
              <hr className='fitting-break'></hr>
            </div>}
        </div>

        <div className="pagination">
          <button
            className="button"
            onClick={() => handleModelPageChange(-1)}
            disabled={modelPage === 1}
          >
            Previous
          </button>
          <span>
            Page {modelPage} of {totalModelPages}
          </span>
          <button
            className="button"
            onClick={() => handleModelPageChange(1)}
            disabled={modelPage === totalModelPages}
          >
            Next
          </button>
        </div>
      </div>
    ));
};

export default CastingView;
